import { createI18n } from 'vue-i18n';
import dateTimeFormats from './l10n/dateTimesFormat';
import { numberFormats } from './l10n/numberFormats';
import en from './locale/en_GB.json';
import it from './locale/it_IT.json';
import dealersEn from '@modules/dealers/i18n/locale/en_GB.json';
import dealersIt from '@modules/dealers/i18n/locale/it_IT.json';
import dispatchersEn from '@modules/dispatchers/i18n/locale/en_GB.json';
import dispatchersIt from '@modules/dispatchers/i18n/locale/it_IT.json';
import templatesEn from '@modules/templates/i18n/locale/en_GB.json';
import templatesIt from '@modules/templates/i18n/locale/it_IT.json';
import importFlowEn from '@modules/import-flow/i18n/locale/en_GB.json';
import importFlowIt from '@modules/import-flow/i18n/locale/it_IT.json';
import dmsEn from '@modules/dms-integration/i18n/locale/en_GB.json';
import dmsIt from '@modules/dms-integration/i18n/locale/it_IT.json';

const DEFAULT_LANG = 'it-IT';

const enMessages = {
  ...en,
  dealers: dealersEn,
  dispatchers: dispatchersEn,
  templates: templatesEn,
  'import-flow': importFlowEn,
  'dms-integration': dmsEn,
};

const itMessages = {
  ...it,
  dealers: dealersIt,
  dispatchers: dispatchersIt,
  templates: templatesIt,
  'import-flow': importFlowIt,
  'dms-integration': dmsIt,
};

function readStoredLocale(): string {
  try {
    return globalThis.localStorage?.getItem('lang') || '';
  } catch {
    return '';
  }
}

export function getLocale(): string {
  const locale = readStoredLocale() || DEFAULT_LANG;
  const language = locale.slice(0, 2);
  return language === 'en' || language === 'it' ? locale : DEFAULT_LANG;
}

export const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  fallbackLocale: DEFAULT_LANG,
  messages: {
    en: enMessages,
    it: itMessages,
    'it-IT': itMessages,
    'en-GB': enMessages,
    'en-US': enMessages,
  },
  datetimeFormats: dateTimeFormats,
  numberFormats,
});

type AppLocale = 'it-IT' | 'en' | 'it' | 'en-GB' | 'en-US';

export function setLocale(locale: string): void {
  i18n.global.locale.value = locale as AppLocale;
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
  try {
    globalThis.localStorage?.setItem('lang', locale);
  } catch {
    // ignore storage failures in restricted environments
  }
}

if (typeof document !== 'undefined') {
  document.documentElement.lang = getLocale();
}
